import { RenderIf } from "../../../helpers/RenderIf"
import { DateFromMiliSeconds } from "../../../helpers/timeFormats"
import React, { useState } from "react"
import { Col, Row } from "reactstrap"
import { T } from "../../../traks"
import { InfoTip } from "../../../c/InfoTip"
import { CollapsibleContainer } from "../../../c/CollapsibleContainer"
import { DaysToDeadline, PastTimeStamp } from "../../../c/TimeComponents"
import { getLastLog } from "../../../c/logs"
import { WhistleStatus } from "c/Traks/WhistleStatus"


const Label = ({ children, ...props }) => {
	const className = props.black ? "fw_700" : "lighter_grey_on_white"
	return (
		<Col xs="3" className={className}>
			{children}
		</Col>
	)
}

const InfoRow = ({ children, ...props }) => {
	let className = "py-3 border-bottom"
	if (props.first) className = "py-3 border-bottom border-top"
	if (props.last) className = "py-3"

	return (
		<Row className={className + " align-items-center"}>
			{children}
		</Row>
	)
}

const InfoContent = ({ children }) => (
	<Col xs="9" className="fw_600 d-flex align-items-center lighter_grey_on_white">
		{children}
	</Col>
)

const CategoriesInput = ({ categories, setCategories, allCategories }) => {
	const [searchTerm, setSearchTerm] = useState('');
	const [suggestedCategories, setSuggestedCategories] = useState([]);
	const [isDropdownVisible, setIsDropdownVisible] = useState(false)

	const handleAddCategory = (category) => {
		setCategories(category);
		setSearchTerm("");
		setSuggestedCategories([]);
	}

	const onKeyDown = (el) => {
		if (el.key === "Enter") {
			handleAddCategory(searchTerm);
		} else if (el.key === "Backspace") {
			setCategories(null, "remove")
			setSuggestedCategories([])
		} else {
			setSearchTerm(el.target.value);
		}
	}

	const handleInputChange = (event) => {
		setSearchTerm(event.target.value);
		updateSuggestions()
	};

	const updateSuggestions = () => {
		setSuggestedCategories(
			allCategories
				.filter(el =>
					!categories.includes(el)
					&& el.toLowerCase().includes(searchTerm.toLowerCase())
				)
		);
	}

	const handleBlur = () => {
		setTimeout(() => {
			setIsDropdownVisible(false)
		}, 200);
	}

	return (
		<div className="position-relative">
			<RenderIf condition={isDropdownVisible}>
				<input
					className="border-0"
					type="text"
					value={searchTerm}
					onKeyDown={onKeyDown}
					autoFocus={true}
					onChange={handleInputChange}
					onFocus={() => {
						setIsDropdownVisible(true)
						updateSuggestions()
					}}
					onBlur={handleBlur}
				/>
				<RenderIf condition={suggestedCategories.length > 0}>
					<div className="position-absolute bg-white w-100 sibilus_border border_radius_6px py-2">
						{suggestedCategories.map((str, index) => (
							<button
								className="dropdown-item py-2 hoverable-grey px-2"
								key={index + "cc"}
								onClick={() => {
									handleAddCategory(str)
									setIsDropdownVisible(false);
								}}
							>
								{str}
							</button>
						))}
					</div>
				</RenderIf>
			</RenderIf>
			<RenderIf condition={!isDropdownVisible}>
				<div
					className="cursor_pointer fw_800 btn"
					onClick={() => setIsDropdownVisible(true)}
				>
					+
				</div>
			</RenderIf>
		</div>
	)
}

const WhistleMode = ({ whistle }) => {
	return (<>
		<RenderIf condition={whistle.mode === "anonymous"}>
			<div>
				<img src="https://static.sibilus.eu/gfx/anonymous-icon-0.svg" alt="anonymous-icon" />
			</div>
			<div className="ms-3">
				<T>Anonymous</T>
			</div>
		</RenderIf>
		<RenderIf condition={whistle.mode !== "anonymous"}>
			<div>
				<img src="https://static.sibilus.eu/gfx/non-anonymous-icon-0.svg" alt="anonymous-icon" />
			</div>
			<div className="ms-3">
				<T>Non-anonymous</T>
			</div>

		</RenderIf>
	</>)
}

const WhistleInfo = ({ whistle, allCategories = [], categories = [], setCategories = null, ...props }) => {
	const hasMode = "mode" in whistle

	const name = (whistleContent) => {
		const rx = /name:\s(.*)/
		const nameExists = rx.exec(whistleContent)
		if (nameExists)
			return nameExists[1]
		return null
	}

	const email = (whistleContent) => {
		const rx = /email:\s(.*)/
		const emailExists = rx.exec(whistleContent)
		if (emailExists)
			return emailExists[1]
		return null
	}

	const phone = (whistleContent) => {
		const rx = /phone number:\s(.*)/
		const phoneExists = rx.exec(whistleContent)
		if (phoneExists)
			return phoneExists[1]
		return null
	}

	const meetingDetails = (whistleContent) => {
		const rx = /.*?Request for physical meeting:\s(.*?)/gms
		const meetingExists = rx.exec(whistleContent)
		if (meetingExists)
			return whistleContent.replace(rx, "$1")
		return null
	}

	return (
		<CollapsibleContainer>
			<div className="d-flex justify-content-between align-items-center">
				<Label black>
					<T>Details</T>
					{" #" + whistle.id.slice(-7)}
				</Label>
				<div className="border_radius_6px sibilus_border px-4 py-2 me-3">
					<img src={"https://static.sibilus.eu/gfx/green-circle-0.svg"} alt="green-circle" className="me-3" />
					{WhistleStatus(whistle.status)}
				</div>
			</div>
			<div className="ms-4 mb-3">
				<RenderIf condition={whistle["categories"] && setCategories}>
					<InfoRow first>
						<Label>
							<T>Categories</T>
						</Label>
						<InfoContent>
							<div className="d-flex flex-wrap">
								{categories.map((el, index) =>
									<div className="d-flex sibilus_border rounded-4 bg_light_grey px-3 py-2 me-2" key={index + "c"}>
										<div>
											{el}
										</div>
										<div
											className="cursor_pointer ms-4 light_grey_on_dark"
											onClick={() => setCategories(el, "remove")}
										>
											x
										</div>
									</div>
								)}
								<div className="d-flex align-items-center me-2">
									<CategoriesInput
										categories={categories}
										setCategories={setCategories}
										allCategories={allCategories}
									/>
								</div>
							</div>
						</InfoContent>
					</InfoRow>
				</RenderIf>
				<RenderIf condition={hasMode}>
					<InfoRow>
						<Label>
							<T>Mode</T>
						</Label>
						<InfoContent>
							<WhistleMode whistle={whistle} />
						</InfoContent>
					</InfoRow>
				</RenderIf>
				<InfoRow>
					<Label>
						<T>Last action</T>
					</Label>
					<InfoContent>
						<div className="d-flex">
							<div>
								{getLastLog(whistle)}
							</div>
							<div className="ms-4 txt_grey_3">
								<PastTimeStamp
									TimeStampInMs={getLastLog(whistle, true)}
								/>
							</div>
						</div>
					</InfoContent>
				</InfoRow>
				<InfoRow>
					<Label>
						<T>Entry date</T>
					</Label>
					<InfoContent>
						{DateFromMiliSeconds(whistle.created_ts)}
					</InfoContent>
				</InfoRow>
				<RenderIf condition={whistle.status !== "deleted"}>
					<InfoRow>
						<Label>
							<T>Next deadline</T>
						</Label>
						<InfoContent>
							<DaysToDeadline deadlineInMs={whistle.expire_ts} />
						</InfoContent>
					</InfoRow>
				</RenderIf>
				<RenderIf condition={name(whistle.content)}>
					<InfoRow>
						<Label>
							<T>Name</T>
						</Label>
						<InfoContent>
							{name(whistle.content)}
						</InfoContent>
					</InfoRow>
				</RenderIf>
				<RenderIf condition={email(whistle.content)}>
					<InfoRow>
						<Label>
							<T>Email</T>
						</Label>
						<InfoContent>
							{email(whistle.content)}
						</InfoContent>
					</InfoRow>
				</RenderIf>
				<RenderIf condition={phone(whistle.content)}>
					<InfoRow>
						<Label>
							<T>Phone</T>
						</Label>
						<InfoContent>
							{phone(whistle.content)}
						</InfoContent>
					</InfoRow>
				</RenderIf>
				<RenderIf condition={meetingDetails(whistle.content)}>
					<InfoRow last>
						<Label>
							<T>Wanting a meeting</T>
							<span className="ms-2">
								<InfoTip>
									<T>The entry reporter whishes a meeting</T>
								</InfoTip>
							</span>
						</Label>
						<InfoContent>
							{meetingDetails(whistle.content)}
						</InfoContent>
					</InfoRow>
				</RenderIf>
			</div>
		</CollapsibleContainer>
	)
}

export default WhistleInfo
